/**
 * Valeurs par défaut pour l'interface d'administration
 * @module admin/constants/defaultValues
 */

/**
 * Options de nettoyage de la base de données par défaut
 * @type {Object}
 */
export const DEFAULT_CLEANUP_OPTIONS = {
  daysToKeep: 30,
  tables: ['all'],
};

/**
 * Pagination par défaut pour les utilisateurs
 * @type {Object}
 */
export const DEFAULT_USERS_PAGINATION = {
  page: 1,
  limit: 50,
  total: 0,
  totalPages: 0,
};

/**
 * Filtres par défaut pour les utilisateurs
 * @type {Object}
 */
export const DEFAULT_USERS_FILTERS = {
  search: '',
  role: '',
  isActive: '',
};

/**
 * Valeurs par défaut pour les options d'événements selon le type
 * @param {string} eventType - Type d'événement
 * @param {Array} fields - Champs de l'événement
 * @returns {Object} Options par défaut
 */
export const getDefaultEventOptions = (eventType, fields) => {
  const defaultOptions = {};
  
  if (!fields) return defaultOptions;

  fields.forEach((field) => {
    // ID Broadcaster par défaut
    if (field.name.includes('broadcaster_user_id')) {
      defaultOptions[field.name] = '428169645';
    }
    
    // Options spécifiques pour les récompenses
    if (
      field.name === 'reward_type' &&
      eventType === 'channel.channel_points_custom_reward_redemption.add'
    ) {
      defaultOptions[field.name] = 'normal';
    }
    
    if (
      field.name === 'reward_title' &&
      eventType === 'channel.channel_points_custom_reward_redemption.add'
    ) {
      defaultOptions[field.name] = 'Ajouter une musique';
    }
    
    // Options spécifiques pour les cheers
    if (field.name === 'user_name' && eventType === 'channel.cheer') {
      defaultOptions[field.name] = 'test_user';
    }
    
    if (field.name === 'bits' && eventType === 'channel.cheer') {
      defaultOptions[field.name] = '25';
    }
    
    if (field.name === 'message' && eventType === 'channel.cheer') {
      defaultOptions[field.name] = 'Bohemian Rhapsody Queen';
    }
  });

  return defaultOptions;
};

/**
 * Mapping des titres de récompense selon le type
 * @type {Object.<string, string>}
 */
export const REWARD_TITLE_MAP = {
  normal: 'Ajouter une musique',
  random: 'Musique aléatoire',
  skip: 'Skip musique',
};

/**
 * Nombre de jours par défaut pour le nettoyage des logs
 * @type {number}
 */
export const DEFAULT_LOG_CLEANUP_DAYS = 7;

/**
 * Limite d'historique Twitch CLI à conserver
 * @type {number}
 */
export const TWITCH_CLI_HISTORY_LIMIT = 50;
